import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import React, { memo, forwardRef } from 'react';
import _Icon from '../../components/Icon/index.js';
import _Link from '../../components/Link/index.js';
import { DropdownContext } from './DropdownContext.js';

var _templateObject, _templateObject2, _templateObject3;
var StyledLink = styled(_Link)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 0.5rem;\n  padding-top: ", ";\n  padding-bottom: ", ";\n\n  &:hover,\n  &:focus {\n    color: ", ";\n    text-decoration: underline;\n    outline: none;\n  }\n"])), function (_ref) {
  var first = _ref.first;
  return first ? '1rem' : null;
}, function (_ref2) {
  var last = _ref2.last;
  return last ? '1rem' : null;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.secondary;
});
var StyledIcon = styled(_Icon)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 1.5rem;\n"])));
var StyledListItem = styled('li')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-top: 0;\n"])));
var handleKeyInputOnMenuItem = function handleKeyInputOnMenuItem(e, onClick, setIsOpen, navigateToNextSibling, navigateToPreviousSibling) {
  var keyEvent = e;
  var keycode = keyEvent.which || keyEvent.charCode || keyEvent.keyCode;
  switch (keycode) {
    case 40:
      // down arrow
      e.preventDefault();
      navigateToNextSibling();
      break;
    case 38:
      // up arrow
      e.preventDefault();
      navigateToPreviousSibling();
      break;
    case 13: // enter
    case 32:
      // space
      e.preventDefault();
      onClick(e);
      setIsOpen(false);
      break;
    case 39: // right arrow
    case 37: // left arrow
    case 27:
      // escape
      e.preventDefault();
      setIsOpen(false);
      break;
  }
};
var handleDropdownItemKeyDown = function handleDropdownItemKeyDown(onClick, setIsOpen, navigateToNextSibling, navigateToPreviousSibling) {
  return function (e) {
    handleKeyInputOnMenuItem(e, onClick, setIsOpen, navigateToNextSibling, navigateToPreviousSibling);
  };
};
var handleDropdownItemClick = function handleDropdownItemClick(onClick, setIsOpen) {
  return function (e) {
    onClick(e);
    setIsOpen(false);
  };
};
var DropdownMenuItem = function DropdownMenuItem(_ref4, ref) {
  var handleFocus = _ref4.handleFocus,
    _ref4$isFirst = _ref4.isFirst,
    isFirst = _ref4$isFirst === void 0 ? false : _ref4$isFirst,
    _ref4$isLast = _ref4.isLast,
    isLast = _ref4$isLast === void 0 ? false : _ref4$isLast,
    item = _ref4.item,
    navigateToNextSibling = _ref4.navigateToNextSibling,
    navigateToPreviousSibling = _ref4.navigateToPreviousSibling;
  return /*#__PURE__*/React.createElement(DropdownContext.Consumer, null, function (_ref5) {
    var iconSize = _ref5.iconSize,
      isOpen = _ref5.isOpen,
      setIsOpen = _ref5.setIsOpen,
      theme = _ref5.theme;
    return /*#__PURE__*/React.createElement(StyledListItem, {
      role: 'none'
    }, /*#__PURE__*/React.createElement(StyledLink, {
      ref: ref,
      role: 'menuitem',
      tabIndex: isOpen ? 0 : -1,
      color: 'black',
      first: isFirst,
      last: isLast,
      theme: theme,
      onFocus: handleFocus,
      onKeyDown: handleDropdownItemKeyDown(item.onClick, setIsOpen, navigateToNextSibling, navigateToPreviousSibling),
      onClick: handleDropdownItemClick(item.onClick, setIsOpen),
      "data-testid": item.testId
    }, /*#__PURE__*/React.createElement("div", null, item.iconName && /*#__PURE__*/React.createElement(StyledIcon, {
      name: item.iconName,
      size: iconSize,
      theme: theme
    })), /*#__PURE__*/React.createElement("div", null, item.text)));
  });
};
var DropdownMenuItem$1 = /*#__PURE__*/memo(/*#__PURE__*/forwardRef(DropdownMenuItem));

export default DropdownMenuItem$1;
